// eslint-disable-next-line import/no-anonymous-default-export
export default `
:root {
  --md-source: #6c4ea2;
  /* primary */
  --md-ref-palette-primary0: #000000;
  --md-ref-palette-primary10: #260058;
  --md-ref-palette-primary20: #3c1c70;
  --md-ref-palette-primary25: #48297c;
  --md-ref-palette-primary30: #543588;
  --md-ref-palette-primary35: #604295;
  --md-ref-palette-primary40: #6c4ea2;
  --md-ref-palette-primary50: #8667bd;
  --md-ref-palette-primary60: #a081d9;
  --md-ref-palette-primary70: #bb9bf6;
  --md-ref-palette-primary80: #d4bbff;
  --md-ref-palette-primary90: #ebdcff;
  --md-ref-palette-primary95: #f7edff;
  --md-ref-palette-primary98: #fef7ff;
  --md-ref-palette-primary99: #fffbff;
  --md-ref-palette-primary100: #ffffff;
  /* secondary */
  --md-ref-palette-secondary0: #000000;
  --md-ref-palette-secondary10: #1f182a;
  --md-ref-palette-secondary20: #342d40;
  --md-ref-palette-secondary25: #3f384c;
  --md-ref-palette-secondary30: #4b4358;
  --md-ref-palette-secondary35: #574f64;
  --md-ref-palette-secondary40: #635b70;
  --md-ref-palette-secondary50: #7c7389;
  --md-ref-palette-secondary60: #968da4;
  --md-ref-palette-secondary70: #b1a7bf;
  --md-ref-palette-secondary80: #cdc2db;
  --md-ref-palette-secondary90: #eadef7;
  --md-ref-palette-secondary95: #f7edff;
  --md-ref-palette-secondary98: #fef7ff;
  --md-ref-palette-secondary99: #fffbff;
  --md-ref-palette-secondary100: #ffffff;
  /* tertiary */
  --md-ref-palette-tertiary0: #000000;
  --md-ref-palette-tertiary10: #32101b;
  --md-ref-palette-tertiary20: #4a252f;
  --md-ref-palette-tertiary25: #57303a;
  --md-ref-palette-tertiary30: #643b45;
  --md-ref-palette-tertiary35: #714651;
  --md-ref-palette-tertiary40: #7f525d;
  --md-ref-palette-tertiary50: #9a6a75;
  --md-ref-palette-tertiary60: #b6838f;
  --md-ref-palette-tertiary70: #d39da9;
  --md-ref-palette-tertiary80: #f1b7c4;
  --md-ref-palette-tertiary90: #ffd9e0;
  --md-ref-palette-tertiary95: #ffecef;
  --md-ref-palette-tertiary98: #fff8f8;
  --md-ref-palette-tertiary99: #fffbff;
  --md-ref-palette-tertiary100: #ffffff;
  /* neutral */
  --md-ref-palette-neutral0: #000000;
  --md-ref-palette-neutral10: #1d1b1e;
  --md-ref-palette-neutral20: #323033;
  --md-ref-palette-neutral25: #3d3a3e;
  --md-ref-palette-neutral30: #48464a;
  --md-ref-palette-neutral35: #545155;
  --md-ref-palette-neutral40: #605d61;
  --md-ref-palette-neutral50: #79767a;
  --md-ref-palette-neutral60: #938f94;
  --md-ref-palette-neutral70: #aeaaae;
  --md-ref-palette-neutral80: #cac5ca;
  --md-ref-palette-neutral90: #e6e1e6;
  --md-ref-palette-neutral95: #f5eff4;
  --md-ref-palette-neutral98: #fef8fc;
  --md-ref-palette-neutral99: #fffbff;
  --md-ref-palette-neutral100: #ffffff;
  /* neutral-variant */
  --md-ref-palette-neutral-variant0: #000000;
  --md-ref-palette-neutral-variant10: #1d1a22;
  --md-ref-palette-neutral-variant20: #332f37;
  --md-ref-palette-neutral-variant25: #3e3a43;
  --md-ref-palette-neutral-variant30: #49454e;
  --md-ref-palette-neutral-variant35: #55515a;
  --md-ref-palette-neutral-variant40: #615c66;
  --md-ref-palette-neutral-variant50: #7a757f;
  --md-ref-palette-neutral-variant60: #948f99;
  --md-ref-palette-neutral-variant70: #afa9b4;
  --md-ref-palette-neutral-variant80: #cbc4cf;
  --md-ref-palette-neutral-variant90: #e7e0eb;
  --md-ref-palette-neutral-variant95: #f6eefa;
  --md-ref-palette-neutral-variant98: #fef7ff;
  --md-ref-palette-neutral-variant99: #fffbff;
  --md-ref-palette-neutral-variant100: #ffffff;
  /* error */
  --md-ref-palette-error0: #000000;
  --md-ref-palette-error10: #410002;
  --md-ref-palette-error20: #690005;
  --md-ref-palette-error25: #7e0007;
  --md-ref-palette-error30: #93000a;
  --md-ref-palette-error35: #a80710;
  --md-ref-palette-error40: #ba1a1a;
  --md-ref-palette-error50: #de3730;
  --md-ref-palette-error60: #ff5449;
  --md-ref-palette-error70: #ff897d;
  --md-ref-palette-error80: #ffb4ab;
  --md-ref-palette-error90: #ffdad6;
  --md-ref-palette-error95: #ffedea;
  --md-ref-palette-error98: #fff8f7;
  --md-ref-palette-error99: #fffbff;
  --md-ref-palette-error100: #ffffff;
  /* light */
  --md-sys-color-primary-light: #6c4ea2;
  --md-sys-color-on-primary-light: #ffffff;
  --md-sys-color-primary-container-light: #ebdcff;
  --md-sys-color-on-primary-container-light: #260058;
  --md-sys-color-secondary-light: #635b70;
  --md-sys-color-on-secondary-light: #ffffff;
  --md-sys-color-secondary-container-light: #eadef7;
  --md-sys-color-on-secondary-container-light: #1f182a;
  --md-sys-color-tertiary-light: #7f525d;
  --md-sys-color-on-tertiary-light: #ffffff;
  --md-sys-color-tertiary-container-light: #ffd9e0;
  --md-sys-color-on-tertiary-container-light: #32101b;
  --md-sys-color-error-light: #ba1a1a;
  --md-sys-color-error-container-light: #ffdad6;
  --md-sys-color-on-error-light: #ffffff;
  --md-sys-color-on-error-container-light: #410002;
  --md-sys-color-background-light: #fffbff;
  --md-sys-color-on-background-light: #1d1b1e;
  --md-sys-color-surface-light: #fffbff;
  --md-sys-color-on-surface-light: #1d1b1e;
  --md-sys-color-surface-variant-light: #e7e0eb;
  --md-sys-color-on-surface-variant-light: #49454e;
  --md-sys-color-outline-light: #7a757f;
  --md-sys-color-inverse-on-surface-light: #f5eff4;
  --md-sys-color-inverse-surface-light: #323033;
  --md-sys-color-inverse-primary-light: #d4bbff;
  --md-sys-color-shadow-light: #000000;
  --md-sys-color-surface-tint-light: #6c4ea2;
  --md-sys-color-outline-variant-light: #cbc4cf;
  --md-sys-color-scrim-light: #000000;
  /* dark */
  --md-sys-color-primary-dark: #d4bbff;
  --md-sys-color-on-primary-dark: #3c1c70;
  --md-sys-color-primary-container-dark: #543588;
  --md-sys-color-on-primary-container-dark: #ebdcff;
  --md-sys-color-secondary-dark: #cdc2db;
  --md-sys-color-on-secondary-dark: #342d40;
  --md-sys-color-secondary-container-dark: #4b4358;
  --md-sys-color-on-secondary-container-dark: #eadef7;
  --md-sys-color-tertiary-dark: #f1b7c4;
  --md-sys-color-on-tertiary-dark: #4a252f;
  --md-sys-color-tertiary-container-dark: #643b45;
  --md-sys-color-on-tertiary-container-dark: #ffd9e0;
  --md-sys-color-error-dark: #ffb4ab;
  --md-sys-color-error-container-dark: #93000a;
  --md-sys-color-on-error-dark: #690005;
  --md-sys-color-on-error-container-dark: #ffdad6;
  --md-sys-color-background-dark: #1d1b1e;
  --md-sys-color-on-background-dark: #e6e1e6;
  --md-sys-color-surface-dark: #1d1b1e;
  --md-sys-color-on-surface-dark: #e6e1e6;
  --md-sys-color-surface-variant-dark: #49454e;
  --md-sys-color-on-surface-variant-dark: #cbc4cf;
  --md-sys-color-outline-dark: #948f99;
  --md-sys-color-inverse-on-surface-dark: #1d1b1e;
  --md-sys-color-inverse-surface-dark: #e6e1e6;
  --md-sys-color-inverse-primary-dark: #6c4ea2;
  --md-sys-color-shadow-dark: #000000;
  --md-sys-color-surface-tint-dark: #d4bbff;
  --md-sys-color-outline-variant-dark: #49454e;
  --md-sys-color-scrim-dark: #000000;
  /* display - large */
  --md-sys-typescale-display-large-font-family-name: 'Roboto Flex';
  --md-sys-typescale-display-large-font-family-style: Regular;
  --md-sys-typescale-display-large-font-weight: 400px;
  --md-sys-typescale-display-large-font-size: 57px;
  --md-sys-typescale-display-large-line-height: 64px;
  --md-sys-typescale-display-large-letter-spacing: -0.25px;
  /* display - medium */
  --md-sys-typescale-display-medium-font-family-name: 'Roboto Flex';
  --md-sys-typescale-display-medium-font-family-style: Regular;
  --md-sys-typescale-display-medium-font-weight: 400px;
  --md-sys-typescale-display-medium-font-size: 45px;
  --md-sys-typescale-display-medium-line-height: 52px;
  --md-sys-typescale-display-medium-letter-spacing: 0px;
  /* display - small */
  --md-sys-typescale-display-small-font-family-name: 'Roboto Flex';
  --md-sys-typescale-display-small-font-family-style: Regular;
  --md-sys-typescale-display-small-font-weight: 400px;
  --md-sys-typescale-display-small-font-size: 36px;
  --md-sys-typescale-display-small-line-height: 44px;
  --md-sys-typescale-display-small-letter-spacing: 0px;
  /* headline - large */
  --md-sys-typescale-headline-large-font-family-name: 'Roboto Flex';
  --md-sys-typescale-headline-large-font-family-style: Regular;
  --md-sys-typescale-headline-large-font-weight: 400px;
  --md-sys-typescale-headline-large-font-size: 32px;
  --md-sys-typescale-headline-large-line-height: 40px;
  --md-sys-typescale-headline-large-letter-spacing: 0px;
  /* headline - medium */
  --md-sys-typescale-headline-medium-font-family-name: 'Roboto Flex';
  --md-sys-typescale-headline-medium-font-family-style: Regular;
  --md-sys-typescale-headline-medium-font-weight: 400px;
  --md-sys-typescale-headline-medium-font-size: 28px;
  --md-sys-typescale-headline-medium-line-height: 36px;
  --md-sys-typescale-headline-medium-letter-spacing: 0px;
  /* headline - small */
  --md-sys-typescale-headline-small-font-family-name: 'Roboto Flex';
  --md-sys-typescale-headline-small-font-family-style: Regular;
  --md-sys-typescale-headline-small-font-weight: 400px;
  --md-sys-typescale-headline-small-font-size: 24px;
  --md-sys-typescale-headline-small-line-height: 32px;
  --md-sys-typescale-headline-small-letter-spacing: 0px;
  /* body - large */
  --md-sys-typescale-body-large-font-family-name: 'Roboto Flex';
  --md-sys-typescale-body-large-font-family-style: Regular;
  --md-sys-typescale-body-large-font-weight: 400px;
  --md-sys-typescale-body-large-font-size: 16px;
  --md-sys-typescale-body-large-line-height: 24px;
  --md-sys-typescale-body-large-letter-spacing: 0.50px;
  /* body - medium */
  --md-sys-typescale-body-medium-font-family-name: 'Roboto Flex';
  --md-sys-typescale-body-medium-font-family-style: Regular;
  --md-sys-typescale-body-medium-font-weight: 400px;
  --md-sys-typescale-body-medium-font-size: 14px;
  --md-sys-typescale-body-medium-line-height: 20px;
  --md-sys-typescale-body-medium-letter-spacing: 0.25px;
  /* body - small */
  --md-sys-typescale-body-small-font-family-name: 'Roboto Flex';
  --md-sys-typescale-body-small-font-family-style: Regular;
  --md-sys-typescale-body-small-font-weight: 400px;
  --md-sys-typescale-body-small-font-size: 12px;
  --md-sys-typescale-body-small-line-height: 16px;
  --md-sys-typescale-body-small-letter-spacing: 0.40px;
  /* label - large */
  --md-sys-typescale-label-large-font-family-name: 'Roboto Flex';
  --md-sys-typescale-label-large-font-family-style: Medium;
  --md-sys-typescale-label-large-font-weight: 500px;
  --md-sys-typescale-label-large-font-size: 14px;
  --md-sys-typescale-label-large-line-height: 20px;
  --md-sys-typescale-label-large-letter-spacing: 0.10px;
  /* label - medium */
  --md-sys-typescale-label-medium-font-family-name: 'Roboto Flex';
  --md-sys-typescale-label-medium-font-family-style: Medium;
  --md-sys-typescale-label-medium-font-weight: 500px;
  --md-sys-typescale-label-medium-font-size: 12px;
  --md-sys-typescale-label-medium-line-height: 16px;
  --md-sys-typescale-label-medium-letter-spacing: 0.50px;
  /* label - small */
  --md-sys-typescale-label-small-font-family-name: 'Roboto Flex';
  --md-sys-typescale-label-small-font-family-style: Medium;
  --md-sys-typescale-label-small-font-weight: 500px;
  --md-sys-typescale-label-small-font-size: 11px;
  --md-sys-typescale-label-small-line-height: 16px;
  --md-sys-typescale-label-small-letter-spacing: 0.50px;
  /* title - large */
  --md-sys-typescale-title-large-font-family-name: 'Roboto Flex';
  --md-sys-typescale-title-large-font-family-style: Regular;
  --md-sys-typescale-title-large-font-weight: 400px;
  --md-sys-typescale-title-large-font-size: 22px;
  --md-sys-typescale-title-large-line-height: 28px;
  --md-sys-typescale-title-large-letter-spacing: 0px;
  /* title - medium */
  --md-sys-typescale-title-medium-font-family-name: 'Roboto Flex';
  --md-sys-typescale-title-medium-font-family-style: Medium;
  --md-sys-typescale-title-medium-font-weight: 500px;
  --md-sys-typescale-title-medium-font-size: 16px;
  --md-sys-typescale-title-medium-line-height: 24px;
  --md-sys-typescale-title-medium-letter-spacing: 0.15px;
  /* title - small */
  --md-sys-typescale-title-small-font-family-name: 'Roboto Flex';
  --md-sys-typescale-title-small-font-family-style: Medium;
  --md-sys-typescale-title-small-font-weight: 500px;
  --md-sys-typescale-title-small-font-size: 14px;
  --md-sys-typescale-title-small-line-height: 20px;
  --md-sys-typescale-title-small-letter-spacing: 0.10px;
}

`;
